<template>
  <span
    >{{ $t('with') }} <i class="fa fa-heart text-green"></i>
    {{ $t('made_in_switzerland') }}</span
  >
</template>

<script>
export default {
  name: 'MadeWithLove',
};
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// src/elements/MadeWithLove.vue